import api from './../../module_user/api/api';
const baseUrl = process.env.VUE_APP_API_URL;

export default {
    async getCampaignDetails(name) {
        let response = await api.get(`${baseUrl}/campaign/${name}`);
        return response.data;
    },
    async getCampaignVideos(name) {
        let response = await api.get(`${baseUrl}/campaign/${name}/videos`);
        return response.data;
    },
    async getLeaderBoard(data) {
        let response = await api.post(baseUrl + '/campaign/upload-user-details-and-get-leaderboard', data);
        return response.data;
    }
}
